import { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Autocomplete,
  InputAdornment,
  Typography,
} from "@mui/material";
import { UseMagLandings } from "../UseMagLandings";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../../RecoilStates";
import { useSnackbar } from "notistack";
import { UseMyPC } from "../../../hooks/UseMyPC";
import SearchIcon from "@mui/icons-material/Search";

export default function SearchArticle(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetArticles, GetArticleByID } = UseMagLandings();
  const [search, setSearch] = useState("");
  const [articleList, setArticleList] = useState([]);
  const [articleById, setArticleById] = useState();
  const [open, setOpen] = useState(false);
  const [productsByWordRes, setProductsByWordRes] = useState();
  const { myPc } = UseMyPC("Default", "Desc");

  function submit() {
    if (search.length > 0) {
      setProgress(true);
      GetArticles(search, myPc, (articles) => {
        setOpen(true);
        setProductsByWordRes(articles.articles);
      });
    } else if (search == "") {
      props.setState({
        ...props.state,
        articleId: undefined,
      });
      setArticleList([]);
    }
  }

  useEffect(() => {
    if (productsByWordRes && productsByWordRes.length == 1) {
      GetArticleByID(productsByWordRes[0].id, (articleById) => {
        setArticleById(articleById);
      });
      setOpen(false);
    } else if (productsByWordRes && productsByWordRes.length > 1) {
      setArticleList(productsByWordRes);
      setOpen(true);
      return;
    } else if (search && productsByWordRes && productsByWordRes.length == 0) {
      enqueueSnackbar("نتیجه ای برای جستجوی شما پیدا نشد", {
        variant: "error",
        autoHideDuration: 2000,
      });
      reset();
      return;
    }
  }, [productsByWordRes]);

  function reset() {
    setOpen(false);
    props.setState({
      ...props.state,
      articleId: undefined,
    });
    setSearch("");
    setArticleList([]);
    setArticleById();
  }

  useEffect(() => {
    if (props.reset) {
      reset();
      props.setReset(false);
    }
  }, [props.reset]);

  useEffect(() => {
    if (articleById) {
      props.setState({
        ...props.state,
        articleId: articleById.id,
      });
      setSearch(articleById.id + " - " + articleById.faTitle);
    } else {
      props.setState({
        ...props.state,
        articleId: undefined,
      });
      setSearch();
    }
  }, [articleById]);

  return (
    <Autocomplete
      filterOptions={(options, state) => options}
      onChange={(evt, value) => {
        if (value) {
          // setArticleList([]);
          setProgress(true);
          GetArticleByID(value.id, (articleById) => {
            setArticleById(articleById);
          });
          setOpen(false);
        } else {
          reset();
        }
      }}
      open={open}
      onClose={() => setOpen(false)}
      disableClearable
      clearOnEscape
      inputValue={search ? search : ""}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          reset();
        }
      }}
      renderOption={(props, option, { selected }) => {
        return (
          <li {...props}>
            <Typography
              sx={{
                color: "secondary.main",
                mx: 2,
              }}
            >
              {option.id} -
            </Typography>
            <Typography>{option.title}</Typography>
          </li>
        );
      }}
      getOptionLabel={(option) => (option ? option.title : "")}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      // getOptionLabel={(option) => {
      //   if (articleList && option) {
      //     return (
      //       articleList?.find((m) => m.id == option).id +
      //       " - " +
      //       articleList?.find((m) => m.id == option).title
      //     );
      //   }
      //   return "";
      // }}
      fullWidth
      options={articleList ? articleList : []}
      renderInput={(params) => (
        <TextField
          onChange={(evt) => {
            setSearch(evt.target.value);
          }}
          error={props.error}
          variant="outlined"
          {...params}
          label="مقاله"
          InputProps={{
            ...params.InputProps,

            startAdornment: (
              <InputAdornment sx={{ m: 0 }} position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: search != "" && (
              <InputAdornment position="end">
                <Button
                  color="secondary"
                  onClick={() => {
                    submit();
                  }}
                >
                  جستجو
                </Button>
                <Button onClick={() => reset()}>پاک کردن</Button>
              </InputAdornment>
            ),
            onKeyDown: (e) => {
              if (e.key === "Enter" && !open) {
                e.stopPropagation();
                submit();
              }
            },
            autoComplete: "off",
          }}
        />
      )}
    />
  );
}
